import React from 'react';
import { githubURL } from '../utils/Manager';

export default function Header() {
    return <>
        <div className="header">
            <font>Spotify<font style={{ color: 'var(--font-color)' }}>Api<img src="https://avatars1.githubusercontent.com/spotify-api" alt="Spotify Logo"/>JS</font></font>

            <div className="links">
                <a href="/">Home</a>
                <a href={githubURL}>GitHub</a>
            </div>
        </div>
    </>
}